<template lang="pug">
    div#translate
        Header
        div.row.cf__main
            div.container
                div.main__header
                    div.half.content__left
                        div.panel.labelLang.is-right
                            dropdown.is-right(:options="languages"  v-model="currentLang" :disabled="false")

                    div.half.swap
                        div.btnSwap(@click="onSwap(currentLang, transferLang)")
                            include ../snippets/swap.pug

                    div.half.content__right
                        div.panel.labelLang
                            dropdown(:options="languages"  v-model="transferLang" :disabled="false" @click="filter(search, currentLang)")
                //main__header

                div.main__content
                    div.half.content__left
                        textarea#textarea.textarea(v-model="search" autofocus @keyup.self="filter(search, currentLang)" v-text="search")

                    div.half.content__right(:class="{'rtl': transferLang === 'he'}")
                        div.tools(:class="{'is-active': words.length !== 0}")
                            div.data.audio
                                span.label(ref="audio" @click="playAudio(translationText, {status: words.length !== 0})" :class="{'is-active': !statAudio}" :data-label="tips.audio.static")
                                    include ../snippets/volume.pug
                            div.data.favorites
                                span.label(ref="favorites" @click="addFavorites(words, {status: words.length !== 0})" :data-label="tips.favorites.static")
                                    include ../snippets/favorites.pug
                            div.data.copy
                                span.label(ref="copy" @click="copyText(translationText, {status: words.length !== 0})" :data-label="tips.copy.static")
                                    include ../snippets/copy.pug

                        ul.transfer
                            li(v-for="(text, i) in translationText" :key="i" :class="{'is-active': text.id === currentAudio}" v-text="text && text[transferLang]")
                //main__content
            //container
        //cf__main

        div.row.cf__description(v-if="isShow(translationText)")
            div.container
                div.tableItems.grid.noCheckbox
                    div.tableContent.mb0
                        div.item.tableItem(v-for="item in translationText" v-if="isDesc(item) || isSameWord(item)")
                            div.tableHeader
                                div.cell.cell-16
                                div.cell.cell-16.pd20 {{item.ru || '-'}}
                                div.cell.cell-16.pd20 {{item.en || '-'}}
                                div.cell.cell-16.pd20 {{item.he || '-'}}
                                div.cell.cell-16.pd20 {{item.cir || '-'}}
                                div.cell.cell-16.pd20 {{item.lat || '-'}}

                            div.row(v-if="isDesc(item)")
                                div.cell.cell-16.cell-cat
                                    div.name Описание
                                div.cell.cell-16.pd20(v-for="(i, key) in languages")
                                    div.name {{item[key+'Desc'] || '-'}}

                            div.row(v-if="isSameWord(item)")
                                div.cell.cell-16.cell-cat
                                    div.name Похожие слова
                                div.cell.cell-16.pd20(v-for="(i, key) in languages")
                                    div.name {{item['sameWords'+ucFirst(key)] || '-'}}
        //cf__description
    //translate
</template>

<script>
import Header from '@/components/Header.vue'
import Dropdown from '@/components/Dropdown';
import WordsService from '@/services/Words';

export default {
    name: 'translate',
    components: {
        Header,
        Dropdown
    },
    data() {
        return {
            languages: {
                ru: 'Русский',
                en: 'Английский',
                he: 'Иврит',
                cir: 'Джуури кириллица',
                lat: 'Джуури латиница'
            },
            tips: {
                audio: {
                    empty: 'Нет озвучки!',
                    static: 'Озвучить',
                    active: ''
                },
                favorites: {
                    empty: 'Пусто!',
                    static: 'Добавить в подборку',
                    active: 'Перевод добавлен в подборку «Избранное»'
                },
                copy: {
                    empty: 'Пусто!',
                    static: 'Копировать',
                    active: 'Перевод скопирован'
                }
            },
            words: [],
            search: '',
            translationText: [],
            currentLang: 'ru',
            transferLang: 'cir',
            statAudio: true,
            currentAudio: '',
        }
    },
    methods: {
        async delay(i) {
            return new Promise(res => {
                setTimeout(() => res(2), i)
            });
        },
        playList(url) {
            //let audio = document.createElement('audio');
            let audio = new Audio();
            audio.src = require(`../../uploads/${url}`);
            audio.style.display = "none";
            audio.autoplay = true;
            audio.onended = () => audio.remove();
            document.body.appendChild(audio);
        },
        async filter(value, lang) {
            let oldLang;
            if (value.length === 0) {
                this.words = [];
                this.translationText = [];
            }
            if (lang === oldLang || value.length !== 0) {
                let regExp = value.trim().split(/(?:\r?\n){1,}/);
                let word = await WordsService.getSearch(regExp, lang).then(i => i.data);
                let wordId = [];
                for (let i = 0; i < word.length; i++) {
                    if (word[i].id !== undefined) wordId.push(word[i].id);
                }
                this.words = wordId;
                this.translationText = word;
                oldLang = lang
            }
        },
        async playAudio(value, code) {
            if (code.status && this.statAudio) {
                let wordsArr = this.words;
                let audioArr = value.sort((a, b) => wordsArr.indexOf(a.id) - wordsArr.indexOf(b.id));
                for (let i = 0; i < audioArr.length; i++) {
                    let sound = audioArr[i].soundJuhuri;
                    if (this.isEmpty(sound)) {
                        this.statAudio = false;
                        this.currentAudio = audioArr[i].id;
                        await this.playList(sound);
                        await this.delay(2000);
                    }
                }
                this.currentAudio = '';
                this.statAudio = true;
            }
        },
        async addFavorites(fav, code) {
            if (code.status) {
                let arrFav = [];
                let state = this.$cookies.isKey('favorites');
                let listFav = this.$cookies.get('favorites');

                if (state && listFav !== null) {
                    let array = listFav.split(',');
                    arrFav.push(array);
                    fav.forEach(i => {
                        if (array.indexOf(String(i)) === -1) {
                            arrFav.push(i);
                        }
                    });
                    this.$cookies.set('favorites', arrFav);
                    this.onChangeTips('favorites', 'active');
                } else {
                    arrFav.push(fav);
                    this.$cookies.set('favorites', arrFav);
                    this.onChangeTips('favorites', 'active');
                }
            }
        },
        async copyText(arr, code) {
            if (code.status) {
                let copy = '';
                arr.forEach((val) => copy += (val[this.transferLang] + ', '));
                this.$copyText(copy.trim()).then(e => {
                    this.onChangeTips('copy', 'active');
                });
            }
        },

        ucFirst(str) {
            if (!str) return str;
            return str[0].toUpperCase() + str.slice(1);
        },
        isEmpty(str) {
            if (typeof str !== "undefined")
                return (str.trim() === '' || str.trim() === '-' || str.trim() === null) ? false : true;
            return false
        },
        isDesc(w) {
            let a = this.isEmpty(w.ruDesc),
                b = this.isEmpty(w.enDesc),
                c = this.isEmpty(w.heDesc),
                d = this.isEmpty(w.latDesc),
                e = this.isEmpty(w.cirDesc);
            return (!a && !b && !c && !d && !e) ? false : true;
        },
        isSameWord(w) {
            let a = this.isEmpty(w.sameWordsRu),
                b = this.isEmpty(w.sameWordsEn),
                c = this.isEmpty(w.sameWordsHe),
                d = this.isEmpty(w.sameWordsLat),
                e = this.isEmpty(w.sameWordsCir);

            return (!a && !b && !c && !d && !e) ? false : true;
        },
        isShow(word) {
            let arr = [];
            for (let index = 0; index < word.length; index++) {
                let w = word[index];
                let a = this.isEmpty(w.ruDesc),
                    b = this.isEmpty(w.enDesc),
                    c = this.isEmpty(w.heDesc),
                    d = this.isEmpty(w.latDesc),
                    e = this.isEmpty(w.cirDesc),
                    f = this.isEmpty(w.sameWordsRu),
                    g = this.isEmpty(w.sameWordsEn),
                    h = this.isEmpty(w.sameWordsHe),
                    i = this.isEmpty(w.sameWordsLat),
                    j = this.isEmpty(w.sameWordsCir);
                arr.push((!a && !b && !c && !d && !e && !f && !g && !h && !i && !j) ? false : true);
            }
            return (arr.indexOf(true) === -1) ? false : true
        },
        onChangeLang(left, right) {
            console.log('-------------');
            if (left === right) {}
        },
        onChangeTips(val, status) {
            let stat;
            switch (status) {
                case 'error':
                    stat = 'error';
                    break;
                case 'active':
                    stat = 'active';
                    break;
                case 'empty':
                    stat = 'empty';
                    break;
            }
            this.$refs[val].dataset.label = this.tips[val][stat];
            setTimeout(() => this.$refs[val].dataset.label = this.tips[val].static, 1000);
        },
        onSwap(left, right) {
            this.currentLang = right;
            this.transferLang = left;
            this.search = "";
            this.translationText.forEach(val => {
                this.search += val[right] + '\n';
            });
        }
    },
    //watch: {search: function (val, oldVal) {}}
}
</script>


